import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import ExpressList from '../entities/back-logistics-list'
import appconst from '@/lib/appconst';


interface ExpressState extends ListState<ExpressList> {
    ExpressInfo: ExpressList,
}

class Expreeimports extends ListModule<ExpressState, any, ExpressList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<ExpressList>(),
        loading: false,
        logisticsInfo: ExpressList,


    }
    actions = {
        async getAll(context: ActionContext<ExpressState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/ExpressImport/GetExpressImportList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<ExpressList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
    };
    mutations = {
        setCurrentPage(state: ExpressState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: ExpressState, pagesize: number) {
            state.pageSize = pagesize;
        },
    }
}

const expressimport = new Expreeimports();
export default expressimport;